import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { PopInput } from "./PopInput";

export function PasswordInput({
  label,
  value,
  onChange,
  error,
  hint,
  placeholder,
  "data-testid": testId,
  autoFocus,
  required,
  minLength,
  ...rest
}) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <PopInput
        type={show ? "text" : "password"}
        label={label}
        value={value}
        onChange={onChange}
        error={error}
        hint={hint}
        placeholder={placeholder}
        data-testid={testId}
        autoFocus={autoFocus}
        required={required}
        minLength={minLength}
        inputClassName="pr-12"
        {...rest}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((v) => !v)}
        className="absolute right-3 inline-flex h-8 w-8 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:text-ink"
        style={{ top: label ? "34px" : "10px" }}
        aria-label={show ? "Hide password" : "Show password"}
      >
        {show ? <EyeOff size={16} strokeWidth={2} /> : <Eye size={16} strokeWidth={2} />}
      </button>
    </div>
  );
}

export default PasswordInput;
